// src/App.js
import React from "react";
import { Routes, Route} from "react-router-dom";
import "./index.css";
import HomePage from "./pages/HomePage";
import NotFound from "./pages/NotFound";
import AppShell from "./components/Layout/AppShell";
import ScrollToTop from "./components/Layout/ScrollToTop";
import PhishingPage from "./pages/PhishingAnalysisPage";
import UnifiedIocValidator from "./components/UnifiedIocValidator/UnifiedIocValidator";
import LoginPage from "./components/LoginPage/LoginPage";
import ProtectedRoute from "./components/ProtectedRoutes/ProtectedRoute";
import QueryGenerator from "./components/QueryGenerator/QueryGenerator";
import VulnerabilityCenter from "./components/VulnerabilityCenter/VulnerabilityCenter";
import UserManagement from "./components/UserManagement/UserManagement";
import UserDetail from "./components/UserManagement/UserDetail";
import ChangePassword from "./components/UserManagement/ChangePassword";
import RequirePasswordChange from "./components/Auth/RequirePasswordChange";
import MyProfilePage from "./pages/MyProfilePage";
import InventoryPage from "./components/VulnerabilityCenter/InventoryPage";
import PhishingAnalysis from "./components/PhishingAnalysis/PhishingAnalysisNAI";
import DefenderSubmissions from "./components/DefenderSubmissions/DefenderSubmissions";
import ThreatIntelligence from "./components/ThreatIntelligence/ThreatIntelligence";
import Dashboard from "./components/Dashboard/Dashboard";
import AdminSettingsPage from "./pages/AdminSettingsPage";
import SsoCallbackPage from "./pages/SsoCallbackPage";

export default function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
      {/* Public */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/sso-callback" element={<SsoCallbackPage />} />

      {/* Change password: protected, but outside AppShell */}
      <Route
        path="/change-password"
        element={
          <ProtectedRoute>
            <RequirePasswordChange>
              <ChangePassword />
            </RequirePasswordChange>
          </ProtectedRoute>
        }
      />

      {/* Protected App (this is now the REAL "/") */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <RequirePasswordChange>
              <AppShell />
            </RequirePasswordChange>
          </ProtectedRoute>
        }
      >
        <Route index element={<HomePage />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="phishing-ai" element={<PhishingPage />} />
        <Route path="phishing" element={<PhishingAnalysis />} />
        <Route path="reported-emails" element={<DefenderSubmissions />} />
        <Route path="threat-intel" element={<ThreatIntelligence />} />
        <Route path="ioc" element={<UnifiedIocValidator />} />
        <Route path="query-generator" element={<QueryGenerator />} />
        <Route path="vulnerabilities" element={<VulnerabilityCenter />} />
        <Route path="admin/users" element={<UserManagement />} />
        <Route path="admin/users/:id" element={<UserDetail />} />
        <Route path="admin/settings" element={<AdminSettingsPage />} />
        <Route path="inventory" element={<InventoryPage />} />
        <Route path="/app/profile" element={<MyProfilePage />} />
      </Route>

      {/* If someone hits random nested paths like /anything */}
      <Route path="*" element={<NotFound />} />
    </Routes>
    </>
  );
}
